import AppVariables from '../Variables.json';

class TimelineReadDto {
	public id: number;
	public contenido: string;
	public year: string;

	private _imgUrl: string;
	public get imgUrl(): string {
		return this._imgUrl;
	}
	public set imgUrl(value: string) {
		this._imgUrl = AppVariables.BASE_URL + value;
	}
}

export default TimelineReadDto;
